// ADR-110: each person chooses their own language (default: the business language) and theme (default: the phone's
// setting). Saved on this device, per user; nothing is sent to the server.
import { isLanguage, type Language } from '../../i18n';

export type Theme = 'system' | 'light' | 'dark';
export const themes: readonly Theme[] = ['system', 'light', 'dark'];

const LANG_KEY = (userId: string) => `yv.lang.${userId}`;
const THEME_KEY = 'yv.theme';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function write(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // Storage blocked: the choice lasts until the app is closed.
  }
}

/** The person's own language, or null to follow the business language. */
export function userLanguage(userId: string): Language | null {
  const v = read(LANG_KEY(userId));
  return isLanguage(v) ? v : null;
}
export function setUserLanguage(userId: string, lang: Language | null) {
  write(LANG_KEY(userId), lang);
}

export function savedTheme(): Theme {
  const v = read(THEME_KEY);
  return v === 'light' || v === 'dark' ? v : 'system';
}
/** Applies and remembers the theme: light or dark set data-theme; system follows prefers-color-scheme. */
export function applyTheme(theme: Theme, save = true) {
  if (theme === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', theme);
  if (save) write(THEME_KEY, theme === 'system' ? null : theme);
}
